const TOKEN = "Admin-Token";
const USERINFO = "User-Info";

export function getToken() {
  return localStorage.getItem(TOKEN);
}

export function setToken(value) {
  return localStorage.setItem(TOKEN, value);
}

export function getUser() {
  return localStorage.getItem(USERINFO);
}

export function setUser(value) {
  return localStorage.setItem(USERINFO, value);
}
